// Casino Table Row Click Handler
// Makes table rows clickable while preserving existing link/button functionality

function handleRowClick(event, row) {
  // Don't navigate if clicking on a link, button, or inside one
  const target = event.target;
  const isClickableElement = target.closest('a, button');
  
  if (!isClickableElement) {
    const url = row.dataset.casinoUrl;
    if (url) {
      window.location.href = url;
    }
  }
}

// Make the function globally available for onclick handlers
window.handleRowClick = handleRowClick;

export { handleRowClick };

